import React from "react";
import { connect } from "react-redux";
import styles from "./VendorAuditModal.module.scss";
import Modal from "components/Modal/Modal";
import Button from "components/Button/Button";
import { bulkUploadAffiliateAction } from "store/actions/Actions";

const VendorAuditModal = (props) => {
    const { AffiliatesAuditReducer } = props;
    return (
        <Modal setShowModal={props.setShowModal} className={styles.modal}>
            <div className={styles["modal-header"]}>
                <h2 className={styles.heading}>Vendor Audit</h2>
            </div>
            <div className={styles["modal-body"]}>
                <div>
                    {AffiliatesAuditReducer.audit && Object.values(AffiliatesAuditReducer.audit).map((section) => {
                        return <div key={section.id}>
                            <div className={styles.section_head}>
                                <div>{section.title}</div>
                                <div>{section.desc}</div>
                            </div>
                            <div>
                                <div className={styles.questions}>
                                {Object.values(section.questions).map((q, id) => {
                                    return <div key={`${q.id}-all`}>
                                        <span>{q.id}</span>
                                        <span>{q.question}</span>
                                        <span>
                                            <input type="radio" id={`${q.id}-yes`} data-sid={section.id} data-qid={id + 1} name={`${q.id}-q`} value="Yes" readOnly checked={q.answer === 'Yes' ? true : false} />
                                            <label htmlFor={`${q.id}-yes`}>Yes</label>
                                            <input type="radio" id={`${q.id}-no`} data-sid={section.id} data-qid={id + 1} name={`${q.id}-q`} value="No" readOnly checked={q.answer === 'No' ? true : false} />
                                            <label htmlFor={`${q.id}-no`}>No</label>
                                            <input type="radio" id={`${q.id}-na`} data-sid={section.id} data-qid={id + 1} name={`${q.id}-q`} value="NA" readOnly checked={q.answer === 'NA' ? true : false} />
                                            <label htmlFor={`${q.id}-na`}>Not Applicable</label>
                                        </span>
                                    </div>
                                })}
                                </div>
                            </div>
                        </div>
                    })}
                </div>
            </div>
            <div className={styles["modal-footer"]}>
                <Button
                    className={styles.button}
                    text="CLOSE"
                    onClick={() => props.setShowModal(false)}
                    color="secondary"
                />
            </div>
        </Modal>
    );
};

const mapStateToProps = state => ({
    AffiliatesAuditReducer: state.AffiliatesAuditReducer,
});

const mapDispatchToProps = {
    bulkUploadAffiliateAction
};

export default connect(mapStateToProps, mapDispatchToProps)(VendorAuditModal);
